export enum Quality {
    LOW,
    MEDIUM,
    HIGH,
}

export default class QualityManager {
    private _quality: Quality;
    public get quality(): Quality {
        return this._quality;
    }
    private _resolution: number;
    public get resolution(): number {
        return this._resolution;
    }

    constructor(resolution: number) {
        this._resolution = resolution;
        this._quality = resolution == 1 ? Quality.HIGH : Quality.LOW;
    }

    public get suffix(): string {
        if (this.quality == Quality.HIGH) return "";
        if (this.quality == Quality.MEDIUM) return "@0.75";
        if (this.quality == Quality.LOW) return "@0.5";
        return "";
    }
}
